import * as Util from './utilities/am-operators.util';

//popups
import noCodePopupHtml from '../components/no-codes-warning-popup/no-codes-popup.html';
import noCodePopupController from '../components/modal-popup-base/modal-popup-base';
import deleteOperatorPopupHtml from '../components/operator-delete-popup/am-operator-delete-popup.html';
import deleteOperatorController from '../components/operator-delete-popup/am-operator-delete-popup.componenet';
import selectOperatorsPopupHtml from '../components/operatos-list-select-popup/am-operators-list-select-popup.html';
import selectOperatorsController from '../components/operatos-list-select-popup/am-operators-list-select-popup';

import { filterData } from '../../../functions/search.functions';

export default class AmOperatorsService {
  constructor(
    $q,
    operatorsAPI,
    amStoreService,
    gettext,
    $filter,
    $uibModal,
    accessManagementAPI,
    amFilterPaginationService,
  ) {
    'ngInject';
    this.$q = $q;
    this.api = operatorsAPI;
    this.amStoreService = amStoreService;
    this.gettext = gettext;
    this.$filter = $filter;
    this.$uibModal = $uibModal;
    this.amAPI = accessManagementAPI;
    this.amFilterPaginationService = amFilterPaginationService;
  }

  operatorsCsvToJson(csvFile) {
    return this.api.operatorsCsvToJson(csvFile);
  }

  bulkCreateOperators(operatorList) {
    return this.api.bulkCreateOperators(operatorList);
  }
  generateCreatedOperatorsCsvData(createdOperatorsFeedback = []) {
    const header = {
      row: 'Row',
      name: 'Name',
      pin: 'PIN',
      ztr_rfid: 'ZTR_RFID',
      ipaf: 'IPAF',
    };
    const data = createdOperatorsFeedback.map((operatorFeed) => {
      const pins = Util.GetAccessCodesType(operatorFeed.operator, 'PIN').join(' - ');
      const ztr_rfids = Util.GetAccessCodesType(operatorFeed.operator, 'ZTR_RFID').join(' - ');
      const ipafs = Util.GetAccessCodesType(operatorFeed.operator, 'IPAF').join(' - ');
      return {
        row: operatorFeed.rowNumber,
        name: operatorFeed.operator.name,
        pin: pins,
        ztr_rfid: ztr_rfids,
        ipaf: ipafs,
      };
    });
    return [header, ...data];
  }
  generateFailedCreateOperatorsCsvData(failedOperatorsFeedback = []) {
    const header = {
      row: 'Row',
      name: 'Name',
      pin: 'PIN',
      ztr_rfid: 'ZTR_RFID',
      ipaf: 'IPAF',
      error: 'Error',
    };
    const data = failedOperatorsFeedback.map((operatorFeed) => {
      const pins = Util.GetCSVRowAccessCodesType(operatorFeed.row, 'PIN');
      const ztr_rfids = Util.GetCSVRowAccessCodesType(operatorFeed.row, 'ZTR_RFID');
      const ipafs = Util.GetCSVRowAccessCodesType(operatorFeed.row, 'IPAF');
      return {
        row: operatorFeed.rowNumber,
        name: operatorFeed.name,
        pin: pins,
        ztr_rfid: ztr_rfids,
        ipaf: ipafs,
        error: this.getOperatorMessages()[operatorFeed.errorCode] || '',
      };
    });
    return [header, ...data];
  }

  getOperatorMessages() {
    return {
      'invalid-code': this.gettext('Invalid code'),
      'invalid-code-format': this.gettext('Invalid code format'),
      'no-name': this.gettext('No name'),
      generale: this.gettext('Problem creating operator'),
    };
  }

  getOperators() {
    return this.api.getOperators().then((respons) => {
      return respons.data;
      //update the store data.
      // this.amStoreService.updateOperators(operators);
      // return this.amStoreService.getStore();
    });
  }

  filterByTerm(data = [], term = '', propertyKeys = []) {
    return filterData(data, term, propertyKeys);
  }

  getOperatorById(id) {
    return this.api.getOperatorById(id).then((respons) => respons.data);
  }

  updateOperatorsCodes(operatorId, outCodes, autoGeneratePin) {
    return this.api.updateOperatorsCodes(operatorId, outCodes, autoGeneratePin).then((respons) => {
      //TODO update viewed operator in the store
      return respons.data;
    });
  }

  updateOperatorMetaData(operatorId, name, attrs) {
    return this.api.updateOperatorMetaData(operatorId, name, attrs).then((respons) => {
      //TODO update viewed operator in the store
      return respons.data;
    });
  }
  createOperator(operatorCreate) {
    return this.api.createOperater(operatorCreate).then((respons) => {
      return respons.data;
    });
  }
  openNoCodeWarningPopup() {
    return this.$uibModal.open({
      animation: true,
      size: 'md',
      template: noCodePopupHtml,
      controller: noCodePopupController,
      controllerAs: 'popupVm',
      resolve: {},
    }).result;
  }
  //this modal will be closed by cancel or close btn only.
  openDeleteOperatorPopup(operator) {
    return this.$uibModal.open({
      animation: true,
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      template: deleteOperatorPopupHtml,
      controller: deleteOperatorController,
      controllerAs: 'deletePopupVm',
      resolve: {
        operator: () => operator,
      },
    }).result;
  }
  deleteOperator(operatorId) {
    return this.api.deleteOperater(operatorId).then((respons) => {
      return respons.data;
    });
  }

  getPagedOperators(filter, paging = {}, data = [], propertyKeys = []) {
    return this.amFilterPaginationService.getPaged(filter, paging, data, propertyKeys);
  }

  openSelectOperatorsPopup(selected = [], excluded = []) {
    return this.$uibModal.open({
      animation: true,
      size: 'lg',
      template: selectOperatorsPopupHtml,
      controller: selectOperatorsController,
      controllerAs: 'opsPopupVm',
      resolve: {
        selected: () => selected || [],
        excluded: () => excluded || [],
      },
    }).result;
  }

  getOperatorsByAssetId(assetId) {
    return this.amAPI.getOperatorsByAsset(assetId).then((respons) => {
      return respons.data;
    });
  }

  filterByExcludedIds(operators = [], excludedIds = []) {
    return operators.filter((op) => !excludedIds.includes(op.id));
  }

  getOperatorExpiryById(id) {
    return this.api.getOperatorExpiryById(id).then((response) => {
      return response.data;
    });
  }
}
